import logo from './resources/img/mgb-logo-1024px.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>MyGymBook</h2>
        <img src={logo} className="App-logo" alt="logo" />
        <p>Soon...</p>
      </header>
    </div>
  );
}

export default App;
